<template>
  <PcAptitudeSafe v-if="isPc"></PcAptitudeSafe>
  <MobileAptitudeSafe v-else></MobileAptitudeSafe>
</template>

<script>
import PcMobile from '@/mixins/PcMoblie'
import MobileAptitudeSafe from './mobile/MobileAptitudeSafe'
import PcAptitudeSafe from './pc/PcAptitudeSafe'

export default {
  name: 'AptitudeSafe',
  mixins: [PcMobile],
  components: {
    MobileAptitudeSafe,
    PcAptitudeSafe,
  },
}
</script>
